// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__container___J95L6 {
  max-width: 1140px !important;
  margin-top: 20px;
  margin-bottom: 15px;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(19, 39, 48, 0.12);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
}
.styles__container___J95L6 section {
  margin-bottom: 45px;
}
.styles__container___J95L6 {
  max-width: 1140px !important;
  margin-top: 20px;
  margin-bottom: 15px;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(19, 39, 48, 0.12);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  background-color: transparent;
  box-shadow: none;
  margin-top: 0;
}
.styles__container___J95L6 section {
  margin-bottom: 45px;
}
.styles__container___J95L6 img {
  max-height: 350px;
  display: inline-block;
  cursor: pointer;
}
.styles__container___J95L6 td {
  width: 50%;
}
.styles__productContent___up0sU {
  max-width: 1140px !important;
  margin-top: 20px;
  margin-bottom: 15px;
  border-radius: 3px;
  box-shadow: 0 2px 4px 0 rgba(19, 39, 48, 0.12);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  background-color: transparent;
  box-shadow: none;
  margin-top: 0;
  padding: 36px 36px 66px 36px;
  background-color: #fff;
}
.styles__productContent___up0sU section {
  margin-bottom: 45px;
}
.styles__productContent___up0sU section {
  margin-bottom: 45px;
}
.styles__productContent___up0sU img {
  max-height: 350px;
  display: inline-block;
  cursor: pointer;
}
.styles__productContent___up0sU td {
  width: 50%;
}
.styles__columnFullWidth___UTevS {
  text-align: right;
}
@media (max-width: 767px) {
  .styles__columnFullWidth___UTevS {
    margin-left: -30px;
    margin-right: -30px;
  }
}
.styles__controls___Vn0tB {
  padding: 30px;
}
@media (max-width: 767px) {
  .styles__controls___Vn0tB {
    padding-bottom: 0px;
  }
}
.styles__controls___Vn0tB button {
  width: 150px;
}
@media (max-width: 767px) {
  .styles__controls___Vn0tB button {
    margin-top: 20px;
    width: 100%;
    height: 48px;
  }
}
.styles__mainControls___B6UwF input {
  border: none;
  box-shadow: none !important;
  border-bottom: 1px solid #ccc;
  margin-top: 20px;
  margin: 0px;
  background: transparent;
  margin-left: 10px;
  width: 150px;
}
.styles__mainControls___B6UwF input[type="number"] {
  width: 100px;
  padding: 2px 5px;
  font-size: 14px;
}
@media (max-width: 767px) {
  .styles__mainControls___B6UwF input[type="number"] {
    width: 50px;
  }
}
.styles__mainInfo___cWKWd {
  padding-bottom: 30px;
  padding-top: 30px;
}
@media (max-width: 991px) {
  .styles__mainInfo___cWKWd {
    padding-bottom: 0px;
  }
}
.styles__mainInfo___cWKWd h2 {
  margin-top: 0px;
}
.styles__marginBottom___Sni9C {
  margin-bottom: 10px;
}
.styles__inline___Sq687 {
  display: flex;
  align-items: center;
}
@media (min-width: 992px) {
  .styles__inline___Sq687 {
    justify-content: flex-end;
  }
}
@media (min-width: 992px) {
  .styles__firstColumn___KZ9YX {
    justify-content: flex-start;
  }
}
.styles__price___s2kHF {
  font-size: 20px;
  font-weight: bold;
  margin-left: 10px;
}
@media (max-width: 991px) {
  .styles__title___z9YwA {
    padding-bottom: 24px;
  }
}
.styles__buttonRow___W8WTR {
  padding-top: 10px;
}
@media (min-width: 768px) {
  .styles__buttonRow___W8WTR {
    display: flex;
    align-items: center;
  }
}
.styles__quantityInCart___vT6tC {
  text-align: right;
  margin-top: 10px;
}
.styles__comment___cPylF {
  margin-top: 20px;
  color: #D9534F;
}
.styles__priceOptions___LqZbs {
  text-align: right;
  padding: 20px;
  position: sticky;
  top: 0;
  background: #eee;
  z-index: 100;
}
.styles__limitedQuantityMessage___MJtgk {
  color: #d9534f;
}
.styles__quantity___aKyAN {
  text-align: right;
}
.styles__description___T0Psd {
  height: 100px;
  overflow: hidden;
}
.styles__readMoreButton____QJS8 {
  background: transparent;
  color: #337ab7;
  border: none;
  outline: none;
}
.styles__buttonWrapper___FuHH9 {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}
.styles__productBadge___ws6qO {
  float: right;
}
@media (max-width: 991px) {
  .styles__productBadge___ws6qO {
    float: none;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
  }
}
.styles__productBadge___ws6qO img {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/shared/layout.less","webpack://./src/components/components/Product/styles.less"],"names":[],"mappings":"AAEA;EACE,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kDAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;ACDF;ADTA;EAYI,mBAAA;ACAJ;AAXA;EDAE,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kDAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;ECCA,6BAAA;EACA,gBAAA;EACA,aAAA;AAcF;AA1BA;EDWI,mBAAA;ACkBJ;AA7BA;EAGI,iBAAA;EACA,qBAAA;EACA,eAAA;AA6BJ;AAlCA;EAQI,UAAA;AA6BJ;AAtBA;EDfE,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,8CAAA;EACA,kDAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;ECCA,6BAAA;EACA,gBAAA;EACA,aAAA;EAKA,4BAAA;EACA,sBAAA;AAmCF;AAtCA;EDJI,mBAAA;AC6CJ;AAzCA;EDJI,mBAAA;ACgDJ;AA5CA;EAZI,iBAAA;EACA,qBAAA;EACA,eAAA;AA2DJ;AAjDA;EAPI,UAAA;AA2DJ;AA9CA;EACE,iBAAA;AAgDF;AA/CE;EAAA;IACE,kBAAA;IACA,mBAAA;EAkDF;AACF;AA/CA;EACE,aAAA;AAiDF;AAhDE;EAAA;IACE,mBAAA;EAmDF;AACF;AAvDA;EAMI,YAAA;AAoDJ;AAnDI;EAAA;IACE,gBAAA;IACA,WAAA;IACA,YAAA;EAsDJ;AACF;AAlDA;EAEI,YAAA;EACA,2BAAA;EACA,6BAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;AAmDJ;AA5DA;EAYI,YAAA;EACA,gBAAA;EACA,eAAA;AAmDJ;AAlDI;EAAA;IACE,WAAA;EAqDJ;AACF;AAjDA;EACE,oBAAA;EACA,iBAAA;AAmDF;AAlDE;EAAA;IACE,mBAAA;EAqDF;AACF;AA1DA;EAOI,eAAA;AAsDJ;AAlDA;EACE,mBAAA;AAoDF;AAjDA;EACE,aAAA;EACA,mBAAA;AAmDF;AAlDE;EAAA;IACE,yBAAA;EAqDF;AACF;AAjDE;EAAA;IACE,2BAAA;EAoDF;AACF;AAjDA;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;AAmDF;AA/CE;EAAA;IACE,oBAAA;EAkDF;AACF;AA/CA;EACE,iBAAA;AAiDF;AAhDE;EAAA;IACE,aAAA;IACA,mBAAA;EAmDF;AACF;AAhDA;EACE,iBAAA;EACA,gBAAA;AAkDF;AA/CA;EACE,gBAAA;EACA,cAAA;AAiDF;AA9CA;EACE,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,MAAA;EACA,gBAAA;EACA,YAAA;AAgDF;AA7CA;EACE,cAAA;AA+CF;AA5CA;EACE,iBAAA;AA8CF;AA3CA;EACE,aAAA;EACA,gBAAA;AA6CF;AA1CA;EACE,uBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;AA4CF;AAzCA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;AA2CF;AAxCA;EACE,YAAA;AA0CF;AAzCE;EAAA;IACE,WAAA;IACA,WAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,mBAAA;EA4CF;AACF;AAzCA;EACE,kBAAA;AA2CF","sourcesContent":["@import './variables.less';\n\n.container {\n  max-width: 1140px !important;\n  margin-top: 20px;\n  margin-bottom: 15px;\n  border-radius: 3px;\n  background-color: #fff;\n  box-shadow: @eon-box-shadow;\n  transition: @eon-transition-default;\n  border-radius: 4px;\n  margin-left: auto;\n  margin-right: auto;\n  section {\n    margin-bottom: 45px;\n  }\n}\n","@import '../../../shared/layout.less';\n@import '../../../shared/variables.less';\n\n.container {\n  .container();\n  img {\n    max-height: 350px;\n    display: inline-block;\n    cursor: pointer;\n  }\n  td {\n    width: 50%;\n  }\n  background-color: transparent;\n  box-shadow: none;\n  margin-top: 0;\n}\n\n.productContent {\n  .container();\n  padding: 36px 36px 66px 36px;\n  background-color: #fff;\n}\n\n.columnFullWidth {\n  text-align: right;\n  @media (max-width: @screen-xs-max) {\n    margin-left: -30px;\n    margin-right: -30px;\n  }\n}\n\n.controls {\n  padding: 30px;\n  @media (max-width: @screen-xs-max) {\n    padding-bottom: 0px;\n  }\n  button {\n    width: 150px;\n    @media (max-width: @screen-xs-max) {\n      margin-top: 20px;\n      width: 100%;\n      height: 48px;\n    }\n  }\n}\n\n.mainControls {\n  input {\n    border: none;\n    box-shadow: none !important;\n    border-bottom: 1px solid #ccc;\n    margin-top: 20px;\n    margin: 0px;\n    background: transparent;\n    margin-left: 10px;\n    width: 150px;\n  }\n  input[type=\"number\"] {\n    width: 100px;\n    padding: 2px 5px;\n    font-size: 14px;\n    @media (max-width: @screen-xs-max) {\n      width: 50px;\n    }\n  }\n}\n\n.mainInfo {\n  padding-bottom: 30px;\n  padding-top: 30px;\n  @media (max-width: @screen-sm-max) {\n    padding-bottom: 0px;\n  }\n  h2 {\n    margin-top: 0px;\n  }\n}\n\n.marginBottom {\n  margin-bottom: 10px;\n}\n\n.inline {\n  display: flex;\n  align-items: center;\n  @media (min-width: @screen-md-min) {\n    justify-content: flex-end;\n  }\n}\n\n.firstColumn {\n  @media (min-width: @screen-md-min) {\n    justify-content: flex-start;\n  }\n}\n\n.price {\n  font-size: 20px;\n  font-weight: bold;\n  margin-left: 10px\n}\n\n.title {\n  @media (max-width: @screen-sm-max)  {\n    padding-bottom: 24px;\n  }\n}\n\n.buttonRow {\n  padding-top: 10px;\n  @media (min-width: @screen-sm-min) {\n    display: flex;\n    align-items: center;\n  }\n}\n\n.quantityInCart {\n  text-align: right;\n  margin-top: 10px;\n}\n\n.comment {\n  margin-top: 20px;\n  color: @eon-text-color-red;\n}\n\n.priceOptions {\n  text-align: right;\n  padding: 20px;\n  position: sticky;\n  top: 0;\n  background: #eee;\n  z-index: 100;\n}\n\n.limitedQuantityMessage {\n  color: @danger;\n}\n\n.quantity {\n  text-align: right;\n}\n\n.description {\n  height: 100px;\n  overflow: hidden;\n}\n\n.readMoreButton {\n  background: transparent;\n  color: #337ab7;\n  border: none;\n  outline: none\n}\n\n.buttonWrapper {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 8px;\n}\n\n.productBadge {\n  float: right;\n  @media (max-width: 991px) {\n    float: none;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 12px;\n  }\n}\n\n.productBadge img {\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles__container___J95L6`,
	"productContent": `styles__productContent___up0sU`,
	"columnFullWidth": `styles__columnFullWidth___UTevS`,
	"controls": `styles__controls___Vn0tB`,
	"mainControls": `styles__mainControls___B6UwF`,
	"mainInfo": `styles__mainInfo___cWKWd`,
	"marginBottom": `styles__marginBottom___Sni9C`,
	"inline": `styles__inline___Sq687`,
	"firstColumn": `styles__firstColumn___KZ9YX`,
	"price": `styles__price___s2kHF`,
	"title": `styles__title___z9YwA`,
	"buttonRow": `styles__buttonRow___W8WTR`,
	"quantityInCart": `styles__quantityInCart___vT6tC`,
	"comment": `styles__comment___cPylF`,
	"priceOptions": `styles__priceOptions___LqZbs`,
	"limitedQuantityMessage": `styles__limitedQuantityMessage___MJtgk`,
	"quantity": `styles__quantity___aKyAN`,
	"description": `styles__description___T0Psd`,
	"readMoreButton": `styles__readMoreButton____QJS8`,
	"buttonWrapper": `styles__buttonWrapper___FuHH9`,
	"productBadge": `styles__productBadge___ws6qO`
};
export default ___CSS_LOADER_EXPORT___;
